'use client';

import { cn } from '@shared/components/shadcn';

type ChipValue<T extends string> = {
  label: string;
  value: T;
};

type ChipProps<T extends string> = {
  label: string;
  value?: T;
  isChecked: boolean;
  isDisabled?: boolean;
  onChange: ({ value, checked }: { value: T; checked: boolean }) => void;
  className?: string;
  'data-testid'?: string;
};

function Chip<T extends string>({ label, value = label as T, isChecked, isDisabled = false, onChange, className, ...props }: ChipProps<T>) {
  const handleClick = () => {
    if (isDisabled) return;
    const newValue = !isChecked;
    onChange({ value, checked: newValue });
  };

  const CHIP_CLASSES = `flex justify-center items-center w-fit cursor-pointer select-none py-2 px-4
  paragraph-explanatory-strong rounded-full bg-container text-foreground
  hover:bg-container-hover data-[checked=true]:bg-container-active
  data-[checked=true]:hover:bg-container-active/80 data-[checked=true]:text-foreground-inverse
  data-[disabled=true]:cursor-not-allowed data-[disabled=true]:bg-container/50
  data-[disabled=true]:text-foreground/50`;

  return (
    <span className={cn(CHIP_CLASSES, className)} onClick={handleClick} data-checked={isChecked} data-disabled={isDisabled} {...props}>
      {label}
    </span>
  );
}

export { Chip, type ChipProps, type ChipValue };
